module.exports = ".programmes {\n    margin-bottom: 30px;\n}"